import { FlexRow } from '@editor/components/utilities/layouts';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const WarningContainer = styled(FlexRow)`
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  margin-bottom: 16px;
  border-radius: ${themeStyle.radiusMedium};
  background-color: ${themeStyle.varAlertRedLight};
`;
